import { createSlice } from "@reduxjs/toolkit";

const surveySlice = createSlice({
  name: 'survey',
  initialState: {
    status: null,
    isLoading: true,
    startMessage: null,
    endMessage: null,
    cancelMessage: null,
    questions: [],
    scenario: {},
    token: null,
    brand: null,
    questionPerPage: null,
    isLastQuestion: true,
    isBusiness: false
  },
  reducers: {
    setSurveyQuestions: (state, action) => {
      return {
        ...state,
        questions: action.payload
      };
    },
    setScenario: (state, action) => {
      return {
        ...state,
        scenario: action.payload
      };
    },
    setIsLoading: (state, action) => {
      return {
        ...state,
        isLoading: action.payload
      };
    },
    setSurveyStatus: (state, action) => {
      return {
        ...state,
        status: action.payload
      };
    },
    setSurveyToken: (state, action) => {
      return {
        ...state,
        token: action.payload
      };
    },
    setSurveyBrand: (state, action) => {
      return {
        ...state,
        brand: action.payload
      };
    },
    setSurveyQuestionPerPage: (state, action) => {
      return {
        ...state,
        questionPerPage: action.payload
      };
    },
    setStartMessage: (state, action) => {
      return {
        ...state,
        startMessage: action.payload
      };
    },
    setEndMessage: (state, action) => {
      return {
        ...state,
        endMessage: action.payload
      };
    },
    setCancelMessage: (state, action) => {
      return {
        ...state,
        cancelMessage: action.payload
      };
    },
    setIsLastQuestion: (state, action) => {
      return {
        ...state,
        isLastQuestion: action.payload
      };
    },
    setIsBusiness: (state, action) => {
      return {
        ...state,
        isBusiness: action.payload
      };
    }
    // setFormFieldValue: (state, action) => {
    //   console.log('setFormFieldValue', action, state);
    // }
  }
});

export const selectSurveyQuestions = (state) => state.survey.questions;
export const selectSurveyIsLoading = (state) => state.survey.isLoading;
export const selectSurveyToken = (state) => state.survey.token;
export const selectSurveyQuestionPerPage = (state) => state.survey.questionPerPage;
export const selectStartMessage = (state) => state.survey.startMessage;
export const selectEndMessage = (state) => state.survey.endMessage;
export const selectCancelMessage = (state) => state.survey.cancelMessage;
export const selectSurveyStatus = (state) => state.survey.status;
export const selectIsLastQuestion = (state) => state.survey.isLastQuestion;
export const selectIsBusiness = (state) => state.survey.isBusiness;

export const selectSurveyAnswers = (state) => {
  return state.survey;
}

export const selectScenario = (state) => state.survey.scenario;

export const {
  setSurveyQuestions,
  setIsLoading,
  setSurveyStatus,
  setSurveyToken,
  setSurveyBrand,
  setSurveyQuestionPerPage,
  setScenario,
  setStartMessage,
  setEndMessage,
  setCancelMessage,
  setIsLastQuestion,
  setIsBusiness
} = surveySlice.actions

export default surveySlice.reducer